"use client";

import { c as _c } from "react/compiler-runtime";
import { NEXTGEN_GENERATOR_BASE_URL } from "@/constants";
import { NextGenToken } from "@/entities/INextgen";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import { numberWithCommas } from "@/helpers/Helpers";
import { useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { mainnet } from "wagmi/chains";
import { NEXTGEN_CHAIN_ID } from "@/components/nextGen/nextgen_contracts";
import styles from "./NextGenToken.module.scss";
import NextGenTokenDownload, { Resolution } from "./NextGenTokenDownload";
export default function NextgenTokenRenderCenter(props) {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col className="pb-3"><h3 className="mb-0">Display Center</h3></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="font-color-h">Rendered Versions:</span>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.token) {
    t2 = <Col sm={12} md={6} className="pb-3 d-flex flex-wrap gap-2">{t1}<NextGenTokenDownload token={props.token} resolution={Resolution["1K"]} /><NextGenTokenDownload token={props.token} resolution={Resolution["2K"]} /><NextGenTokenDownload token={props.token} resolution={Resolution["4K"]} /><NextGenTokenDownload token={props.token} resolution={Resolution["8K"]} /><NextGenTokenDownload token={props.token} resolution={Resolution["16K"]} /></Col>;
    $[2] = props.token;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="font-color-h">For Thumbnail Use Only :</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props.token) {
    t4 = <Col sm={12} md={6} className="pb-3 d-flex flex-column gap-2">{t3}<NextGenTokenDownload token={props.token} resolution={Resolution.Thumbnail} /><NextGenTokenDownload token={props.token} resolution={Resolution["0.5K"]} /></Col>;
    $[5] = props.token;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Row>{t2}{t4}</Row>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== props.token) {
    t6 = <Row className="pt-3"><CustomRender token={props.token} /></Row>;
    $[10] = props.token;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Container className="no-padding">{t0}{t5}{t6}</Container>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function CustomRender(props) {
  const $ = _c(42);
  enum RenderType {
    ANIMATED = "Animated",
    STATIC = "Static",
  }
  enum ScriptVersion {
    FINAL = "Final",
    OG = "OG",
  }
  const [renderType, setRenderType] = useState(RenderType.ANIMATED);
  const [scriptVersion, setScriptVersion] = useState(ScriptVersion.FINAL);
  const [height, setHeight] = useState(null);
  let t0;
  if ($[0] !== height || $[1] !== props.token.id || $[2] !== renderType || $[3] !== scriptVersion) {
    t0 = function go() {
      let url = `${NEXTGEN_GENERATOR_BASE_URL}/${NEXTGEN_CHAIN_ID === mainnet.id ? "mainnet" : "testnet"}/html/${props.token.id}`;
      const params = new URLSearchParams();
      if (renderType === RenderType.STATIC) {
        params.append("render_static", "true");
      }
      if (scriptVersion === ScriptVersion.OG) {
        params.append("render_og", "true");
      }
      if (height) {
        params.append("height", height.toString());
      }
      if (params.toString()) {
        url = url + `?${params.toString()}`;
      }
      window.open(url, "_blank");
    };
    $[0] = height;
    $[1] = props.token.id;
    $[2] = renderType;
    $[3] = scriptVersion;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const go = t0;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      minHeight: "150px"
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Row><Col><span className="font-color-h">Custom Render:</span></Col></Row>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="font-color-h">Render Type:</span>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== renderType) {
    t4 = <Dropdown.Toggle>{renderType}</Dropdown.Toggle>;
    $[8] = renderType;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Dropdown.Menu>{Object.values(RenderType).map(type => <Dropdown.Item key={getRandomObjectId()} onClick={() => {
        setRenderType(type as RenderType);
      }}>{type}</Dropdown.Item>)}</Dropdown.Menu>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <Dropdown drop="down-centered" className={`${styles.customRenderDropdown} d-flex align-items-center gap-2`}>{t3}{t4}{t5}</Dropdown>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="font-color-h">Script Version:</span>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== scriptVersion) {
    t8 = <Dropdown.Toggle>{scriptVersion}</Dropdown.Toggle>;
    $[14] = scriptVersion;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Dropdown.Menu>{Object.values(ScriptVersion).map(version => <Dropdown.Item key={getRandomObjectId()} onClick={() => {
        setScriptVersion(version as ScriptVersion);
      }}>{version}</Dropdown.Item>)}</Dropdown.Menu>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = <Dropdown drop="down-centered" className={`${styles.customRenderDropdown} d-flex align-items-center gap-2`}>{t7}{t8}{t9}</Dropdown>;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="font-color-h">Height:</span>;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== height) {
    t12 = height ? `${numberWithCommas(height)} px` : "Screen Size";
    $[20] = height;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <Dropdown.Toggle>{t12}</Dropdown.Toggle>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Dropdown.Item onClick={() => {
      setHeight(null);
    }}>Screen Size</Dropdown.Item>;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span>Custom Height (pixels):</span>;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = height ?? "";
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = e_0 => {
      setHeight(parseInt(e_0.target.value));
    };
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t16) {
    t18 = <Dropdown.Menu>{t14}<Dropdown.Item onClick={_temp}><span className="d-flex gap-2">{t15}<input type="number" placeholder="enter height" className={styles.customRenderInput} value={t16} onChange={t17} /></span></Dropdown.Item></Dropdown.Menu>;
    $[27] = t16;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t13 || $[30] !== t18) {
    t19 = <Dropdown drop="down-centered" className={`${styles.customRenderDropdown} d-flex align-items-center gap-2`}>{t11}{t13}{t18}</Dropdown>;
    $[29] = t13;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== go) {
    t20 = () => {
      go();
    };
    $[32] = go;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span>GO!</span>;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t20) {
    t22 = <button className={`pt-2 pb-2 seize-btn no-wrap ${styles.sceneBtn}`} onClick={t20}>{t21}</button>;
    $[35] = t20;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t10 || $[38] !== t19 || $[39] !== t22 || $[40] !== t6) {
    t23 = <Container style={t1}>{t2}<Row><Col className="d-flex flex-wrap gap-2">{t6}{t10}{t19}{t22}</Col></Row></Container>;
    $[37] = t10;
    $[38] = t19;
    $[39] = t22;
    $[40] = t6;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  return t23;
}
function _temp(e) {
  e.preventDefault();
  e.stopPropagation();
}